module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Loyal to the Sky")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e113"
    }
  }, [_c('p', {
    attrs: {
      "id": "d7e2227"
    }
  }, [_c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e2277"
    }
  }, [_c('br'), _vm._v(" The accounts in this book are all based on real people and events, but some have been condensed or conflated. Names have been changed in some places, and a few of the characters are composites. I have on occasion altered the setting or timing of a revelation or personal experience. But throughout the book I have searched for and striven to relate the heart of the story—my own, as well as those of the individuals and communities I have been blessed to encounter along the way."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e2507"
    }
  }, [_c('br'), _vm._v(" Page vii used by permission of Joanna Macy")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e2557"
    }
  }, [_c('br'), _vm._v(" The illustration for the "), _c('span', {
    attrs: {
      "href": "#/SanFrancisco",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("poster")]), _vm._v(" appears by permission of the artist, Mona Caron. © 2003 by Mona Caron. The text for the poster was written by Chris Carlsson and is used with his permission. © 2003 by Chris Carlsson.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e2777"
    }
  }, [_c('br'), _vm._v(" Full texts of the article by Patrick Reinsborough mentioned in chapter 7 and the article by Ilyse Hogue and Patrick Reinsborough mentioned in chapter 8 are posted at "), _c('a', {
    attrs: {
      "href": "http://www.smartmeme.com",
      "id": "d14e132",
      "target": "_blank"
    }
  }, [_vm._v("www.smartmeme.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc8665d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AUTHORSNOTE.vue
// module id = 72
// module chunks = 0